export function getTreatmentPlanName(plan_name, group_name) {
  return plan_name ? `${plan_name} - ${group_name}` : 'No treatment plan'
}
